import { createGlobalStyle } from 'styled-components';

import { darkTheme } from './darkTheme';
import { lightTheme } from './lightTheme';
import { Theme } from '../types';

const generateCssVariables = (theme: Theme) =>
  Object.entries(theme.palette)
    .map(([section, colors]) =>
      Object.entries(colors)
        .map(([key, value]) => `--${section}-${key}: ${value};`)
        .join('\n')
    )
    .join('\n');

const lightThemeCss = generateCssVariables(lightTheme);
const darkThemeCss = generateCssVariables(darkTheme);

export const GlobalStyles = createGlobalStyle`
  :root {
    ${lightThemeCss};
  }

  [data-theme="dark"] {
    ${darkThemeCss};
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    text-size-adjust: none;
    -webkit-backface-visibility: hidden;
  }

  body, button, input, textarea, select {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
    line-height: 1.2;
  }

  body {
    -webkit-font-smoothing: antialiased;
    background: var(--bg-main);

    &.ios {
      overscroll-behavior: none;
    }
  }

  img {
    max-width: 100%;
    font-style: italic;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:focus {
    transition: background-color 0.6s 0s, color 0.6s 0s;
  }

  input[type=file] {
    display: none;
  }
`;
